/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_ReplyInputs */

const cs_messages_reply = /** @type {(inputs: Messages_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpovědět`)
};

const en_messages_reply = /** @type {(inputs: Messages_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply`)
};

/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Messages_ReplyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply = /** @type {((inputs?: Messages_ReplyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_ReplyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply(inputs)
	return cs_messages_reply(inputs)
});